import { Expression, NamedColumn, SqlOptions } from '../../types';
import customHandlers from './custom-formatters/custom-handlers';

export default function stringFormatter(
  column: NamedColumn, expression: Expression, sqlOptions: SqlOptions,
): Expression {
  if (expression.operator) {
    return expression;
  }

  if (column.field === 'ccc1') {
    const handled = customHandlers(column, expression, sqlOptions);
    if (handled != null) {
      return handled;
    }
  }

  return {
    field: column.identifier(),
    operator: 'text_contain',
    value: expression.value,
  };
}
